<template>
<div>
  <div v-if="user.role_id === 1" class="elr-row pony-add-images">
    <div class="elr-col-full">
      <h2 class="info-section-heading">Add Pony Images</h2>
      <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
    </div>
  </div>
</div>
</template>

<script>
// import $ from 'jquery';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import { getCookie } from '../../utils/helpers';
const path = process.env.VUE_APP_ROOT_API;

export default {
  name: 'PonyImageManager',
  props: {
    user: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      errors: [],
    };
  },
  // mounted() {
  //   this.dropzoneOptions.url = this.formUrl;
  // },
  // watch: {
  //   id() {
  //     this.dropzoneOptions.url = this.formUrl;
  //   }
  // },
  computed: {
    token() {
      return getCookie('token');
    },
    dropzoneOptions() {
      return {
        url: `${path}/pony/${this.id}/images`,
        thumbnailWidth: 150,
        maxFilesize: 2,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': path,
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`,
        }
      }
    }
  },
  methods: {}
};
</script>
